/* Public references only. A future account adapter implements load/save; no account is required. */
(function (scope) {
  'use strict';
  if (scope.NektarWishlistStore) return;
  const key = 'nektar:wishlist:v1', limit = 100;
  const id = value => /^(?:[1-9]\d{0,19})$/.test(String(value || '')) ? String(value) : null;
  const handle = value => typeof value === 'string' && /^[a-z0-9][a-z0-9-]{0,200}$/.test(value);
  function normalize(value) {
    const result = [];
    for (const raw of Array.isArray(value) ? value.slice(0, 1000) : []) {
      const item = typeof raw === 'string' ? { productHandle: raw } : raw;
      if (!item || !handle(item.productHandle) || result.some(r => r.productHandle === item.productHandle || (id(item.productId) && r.productId === id(item.productId)))) continue;
      result.push({ productHandle: item.productHandle, productId: id(item.productId), ...(id(item.variantId) ? { variantId: id(item.variantId) } : {}) });
      if (result.length === limit) break;
    }
    return result;
  }
  function localAdapter(storage) {
    return {
      load() { const raw = storage.getItem(key); return JSON.parse(raw ?? storage.getItem('nektar-wishlist-v1') ?? '[]'); },
      save(value) { storage.setItem(key, JSON.stringify(value)); }
    };
  }
  function create(adapter) {
    let entries = [], persistent = true;
    const listeners = new Set(), snapshot = () => entries.map(e => ({ ...e }));
    const load = () => { if (persistent) try { entries = normalize(adapter.load()); } catch { persistent = false; } };
    load();
    function changed() { for (const listener of listeners) listener(snapshot()); }
    function persist() { try { adapter.save(snapshot()); } catch { persistent = false; } changed(); }
    return Object.freeze({
      snapshot, persistent: () => persistent,
      has: value => entries.some(e => e.productHandle === value),
      subscribe(listener) { listeners.add(listener); return () => listeners.delete(listener); },
      sync() { const before = JSON.stringify(entries); load(); if (before !== JSON.stringify(entries)) changed(); },
      toggle(raw) {
        const item = normalize([raw])[0]; if (!item) return { status: 'invalid' };
        load(); // Merge against the latest other-tab state before a user action.
        const prior = entries.find(e => e.productHandle === item.productHandle || (item.productId && e.productId === item.productId));
        if (!prior && entries.length >= limit) return { status: 'full' };
        entries = prior ? entries.filter(e => e !== prior) : [...entries, item]; persist();
        return { status: prior ? 'removed' : 'added', item: prior || item };
      },
      remove(productHandle) { load(); const count = entries.length; entries = entries.filter(e => e.productHandle !== productHandle); if (count !== entries.length) persist(); }
    });
  }
  scope.NektarWishlistStore = Object.freeze({ key, limit, normalize, localAdapter, create });
})(globalThis);
